import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FullTable } from 'components';
import { ACTION_TYPE, authorizationApptBody, authorizationApptHeight } from './constants';
import { clientActions, httpRequestsOnSuccessActions } from 'store';
import { ScheduleDetails } from 'fragments';
import { useModal, useSecondaryModal } from 'utils';

const RENDER_APPOINTMENTS_LIST = 'RENDER_APPOINTMENTS_LIST';

/**
 * Runs `onClose` when the appointment details modal closes (unmounts), however
 * it closes and whatever was done in it.
 */
const RefreshOnClose = ({ onClose, children }) => {
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;
    useEffect(() => () => onCloseRef.current?.(), []);
    return children;
};

export const AuthorizationAppt = ({ info }) => {
    const appt = useSelector((state) => state.client.clientsAuthorizationAppt);
    const client = useSelector((state) => state.client.clientItemInfo);
    const dispatch = useDispatch();
    const { openSecondary } = useSecondaryModal();
    const { close } = useModal();
    useEffect(() => {
        getClientAuthAppt();
    }, []);

    const getClientAuthAppt = (loading) => {
        dispatch(clientActions.getClientsAuthorizationsAppt(info?.id, info?.itemStatus, loading));
    };

    /**
     * Opening an appointment closes this list modal (see the row click), so this
     * component is unmounted while the appointment is changed — an effect here
     * can never see the change. Refresh the authorizations (units) from the
     * details modal instead: after each successful action (`getAfterSuccess`)
     * and once more when it closes, which also covers Complete (it only raises
     * RENDER_APPOINTMENTS_LIST, with no callback). `client.id` is captured at
     * click time; `dispatch` stays valid after unmount.
     */
    const refreshAuthorizations = (clientId) => {
        dispatch(httpRequestsOnSuccessActions.removeSuccess(RENDER_APPOINTMENTS_LIST));
        if (clientId) dispatch(clientActions.getClientAuthorization(clientId, 'noLoad'));
    };

    return (
        <div style={{ width: 1200, maxWidth: '100%' }}>
            <p className="appointments-for">{`Appointments for ${info?.service?.cptCode}`}</p>
            <FullTable
                margin={'0'}
                generateTable={true}
                height={'medium'}
                head={authorizationApptHeight}
                body={authorizationApptBody()}
                loadingType={ACTION_TYPE}
                list={appt?.length ? appt : []}
                handleClickButton={(item) => {
                    const clientId = client?.id;
                    close();
                    openSecondary(
                        <RefreshOnClose onClose={() => refreshAuthorizations(clientId)}>
                            <ScheduleDetails currentId={item?.id} getAfterSuccess={() => refreshAuthorizations(clientId)} />
                        </RefreshOnClose>
                    );
                }}
                noText={'Appointment'}
                activeRowId={''}
            />
        </div>
    );
};
